import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import { SortableContainer, SortableElement, arrayMove } from 'react-sortable-hoc';
import { ImageDetails } from '../';
import './styles.scss';

const LivecamItem = SortableElement(({ livecam }) =>
  (<div className="favorite-cam-item-wrap cam-container col-4 editing">
    <ImageDetails
      className="cam-item"
      isActive={livecam.live}
      imgSrc={livecam.thumbnail_large_url.replace('http://', 'https://')}
      to={livecam.slug}
      camId={livecam.id}
      fallbackImgSrc={livecam.thumbnail_large_url.replace('http://', 'https://')}
      imgHeight={'auto'}
      imgWidth={'100%'}
      lazyLoad={false}
    >
      <div
        className={'not-watching'}
        data-default-title={livecam.title}
      >
        <span className={'text-capitalize u-font-foundation-roman u-textSize-18'}>
          {livecam.title}
        </span>
        {livecam.current_viewers > 0 && <div className="cam-item-separator"></div>}
      </div>
      { livecam.current_viewers > 0 &&
      <div>
        <div className="text-uppercase u-font-foundation-light u-textSize-16">
          { livecam.current_viewers} viewers
        </div>
      </div>
      }
    </ImageDetails>
  </div>),
);

const LivecamList = SortableContainer(({ items }) => {
  return (
    <div className="row">
      {items.map((value, index) => (
        <LivecamItem key={`item-${value.id}`} index={index} livecam={value} />
      ))}
    </div>
  );
});

const propTypes = {
  livecams: PropTypes.array,
  updatedSortedItems: PropTypes.func,
}

const defaultProps = {
  livecams: [],
  uupdatedSortedItems: _.noop,
}

class EditLivecamOrder extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      items: []
    };
    this.onSortEnd = this.onSortEnd.bind(this);
  }

  componentWillMount() {
    this.setState({ items: this.props.livecams });
  }

  componentWillReceiveProps(nexProps) {
    this.setState({ items: nexProps.livecams });
  }

  onSortEnd({ oldIndex, newIndex }) {
    const items = arrayMove(this.state.items, oldIndex, newIndex);
    this.setState({
      items,
    });
    this.props.updatedSortedItems(items);
  };

  render() {
    return <LivecamList items={this.state.items} onSortEnd={this.onSortEnd} axis={'xy'} />;
  }

}

EditLivecamOrder.propTypes = propTypes;
EditLivecamOrder.defaultProps = defaultProps;

export default EditLivecamOrder;
